import React from 'react';
import PropTypes from 'prop-types';
import { StyledBackgroundImg } from './styled';

const BackgroundImg = ({align, alt, src, className, ...rest}) => {
  return src&&src!=='null'?(
    <StyledBackgroundImg
      {...rest}
      align={align}
      src={src}
      className={className}
    >
      <img src={src} alt={alt || ''} />
    </StyledBackgroundImg>
  ):null
};

BackgroundImg.defaultProps = {
  align: 'cc'
};

BackgroundImg.propTypes = {
  /* NOTE: Pieļaujam arī custom pozicionēšanu,
  balstītu uz procentuāli izteiktām vērtībām.
  align: PropTypes.oneOf([
    'lt', 'lc', 'lb',
    'rt', 'rc', 'rb',
    'ct', 'cc', 'cb',
  ]), */
  align: PropTypes.string,
  alt: PropTypes.string,
  src: PropTypes.string,
};

export default BackgroundImg;



// WEBPACK FOOTER //
// ./src/elements/util/BackgroundImg/BackgroundImg.jsx